import CrudCustom from '../../../libs/custom/CrudCustom';

let KomponenPenghasilanService = new CrudCustom('/komponen-penghasilans');
export default KomponenPenghasilanService;
